import { createAction } from 'redux-actions';

import types from './types';

const setProfile = createAction(types.SET_PROFILE);
const setProfileDone = createAction(types.SET_PROFILE_DONE);
const setCustomerStatusNotUpdated = createAction(types.SET_WARNING_MESSAGE);
const setChildren = createAction(types.SET_CHILDREN);
const loadProfile = createAction(types.LOAD_PROFILE);
const setBabyborn = createAction(types.SET_BABYBORN);
const setLoading = createAction(types.SET_LOADING);
const acceptPrivacyPolicy = createAction(types.ACCEPT_PRIVACY_POLICY);
const setCustomerStatusDelay = createAction(types.SET_STATUS_DELAY);
const setCustomerStatusRetry = createAction(types.SET_STATUS_RETRY);
const setLoyaltyCardValue = createAction(types.SET_LOYALTY_CARD);
const setCustomerStatusBeforeAttemptDelay = createAction(types.SET_STATUS_BEFORE_ATTEMPT_DELAY);
const setPendingSubscription = createAction(types.SET_PENDING_SUBSCRIPTION);
const setRegisteredOnCheckout = createAction(types.SET_REGISTERED_ON_CHECKOUT);
const dismissBirthDatePopup = createAction(types.DISMISS_BIRTH_DATE_POPUP);
const setLastViewedProductsCleared = createAction(types.SET_LAST_VIEWED_PRODUCTS_CLEARED);
const setUserPopoverInfo = createAction(types.SET_USER_POPOVER_INFO);
const loadLoyaltyCheques = createAction(types.LOAD_LOYALTY_CHEQUES);
const getLoyaltyCheques = createAction(types.GET_LOYALTY_CHEQUES);
const setLoyaltyChequeError = createAction(types.SET_LOYALTY_CHEQUE_ERROR);
const checkLoggedStatus = createAction(types.CHECK_LOGGED_STATUS);
const setAustria = createAction(types.SET_AUSTRIA);
const setGermany = createAction(types.SET_GERMANY);
const enableForNonVerifiedUser = createAction(types.ENABLE_FOR_NON_VERIFIED_USER);
const updateProfile = createAction(types.UPDATE_PROFILE);

export default {
    setProfile,
    setCustomerStatusNotUpdated,
    setChildren,
    loadProfile,
    setBabyborn,
    setLoading,
    acceptPrivacyPolicy,
    setCustomerStatusDelay,
    setLoyaltyCardValue,
    setCustomerStatusRetry,
    setCustomerStatusBeforeAttemptDelay,
    setPendingSubscription,
    setRegisteredOnCheckout,
    dismissBirthDatePopup,
    setLastViewedProductsCleared,
    setUserPopoverInfo,
    loadLoyaltyCheques,
    getLoyaltyCheques,
    setLoyaltyChequeError,
    checkLoggedStatus,
    setGermany,
    setAustria,
    enableForNonVerifiedUser,
    setProfileDone,
    updateProfile,
};
